import Swal from 'sweetalert2'

const _Alert = Swal.mixin({
    title: '',
    heightAuto: false,
})

let timerInterval = null

export default class Alert {

    static success(message) {
        _Alert.fire({
            html: message,
            icon: 'success',
        })
    }

    static error(message) {
        _Alert.fire({
            html: message,
            icon: 'error',
        })
    }

    static danger(message) {
        _Alert.fire({
            html: message,
            icon: 'error',
        })
    }

    static warning(message) {
        _Alert.fire({
            html: message,
            icon: 'warning',
        })
    }

    static info(message) {
        _Alert.fire({
            html: message,
            icon: 'info',
        })
    }

    static question(message) {
        _Alert.fire({
            html: message,
            icon: 'question',
        })
    }

    static timer(message, icon = 'success', confirmButtonText = 'Ok', confirmButtonColor = '#5F91BA') {
        return new Promise((resolve, reject) => {
            _Alert.fire({
                html: message,
                icon: icon,
                confirmButtonColor: confirmButtonColor,
                confirmButtonText: confirmButtonText,
            }).then(resolve).catch(reject)
        })
    }

    static confirmation(message, icon = 'question', showCancelButton = true, confirmButtonText = 'Ok', confirmButtonColor = '#5F91BA', cancelButtonColor = '#D33') {
        return new Promise((resolve, reject) => {
            _Alert.fire({
                html: message,
                icon: icon,
                showCancelButton: showCancelButton,
                cancelButtonColor: cancelButtonColor,
                confirmButtonColor: confirmButtonColor,
                confirmButtonText: confirmButtonText,
            }).then(result => {
                if (result.value) resolve(true)
                else reject(false)
            }).catch(() => {
                reject(false);
            })
        })
    }



    static interval(message, timer, icon = 'success') {
        let timerInterval;
        return new Promise((resolve, reject) => {
            _Alert.fire({
                html: message,
                icon: icon,
                timer: timer,
                timerProgressBar: true,
                didOpen() {
                    timerInterval = setInterval(() => {
                        Swal.getHtmlContainer().querySelector('strong')
                            .textContent = (Swal.getTimerLeft() / 1000)
                            .toFixed(0)
                    }, 100)
                },
                willClose: () => {
                    clearInterval(timerInterval)
                }
            }).then(result => {
                resolve(true)
            }).catch(() => {
                reject(false);
            })
        })
    }
}
